module.exports = __webpack_public_path__ + "img/close-image.e1bb760f.png";